'use client'

import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'
import { getDefaultLocation } from '@/lib/services/actions/inquiry'
import { ColourConsultForm } from './colour-consult-form'

export interface ColourConsultCTAProps {
  children: React.ReactNode
}

export function ColourConsultCTA({ children }: ColourConsultCTAProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [location, setLocation] = useState<{ id: string; name: string; email: string } | null>(null)

  useEffect(() => {
    if (isOpen && !location) {
      getDefaultLocation().then((loc) => {
        if (loc) setLocation({ id: loc.id, name: loc.name, email: loc.email || 'hello@choice.graphics' })
      })
    }
  }, [isOpen, location])

  return (
    <div className='my-8 flex justify-center'>
      <Button variant='primary' size='lg' onPress={() => setIsOpen(true)}>
        {children}
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title='Book a Colour Consult'
        size='lg'
        scrollBehavior='inside'
      >
        {location ? (
          <ColourConsultForm
            locationId={location.id}
            locationEmail={location.email}
            onSubmitted={() => setIsOpen(false)}
          />
        ) : (
          <p className='py-8 text-center text-sm text-muted'>Loading...</p>
        )}
      </Modal>
    </div>
  )
}
